import React from 'react';
import { ArrowLeftIcon, CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FontComparisonPage() {
  return <div className="min-h-screen bg-[#f8f8f8] text-[#111111] pb-24" data-id="element-1794" data-mp="1gsf35yrgzt9e">
      {/* Load fonts locally */}
      <style data-id="element-1795" data-mp="1lnb5psuc1z0r">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=IBM+Plex+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap');
          
          .font-atkinson {
            font-family: 'Atkinson Hyperlegible', sans-serif;
          }
          
          .font-ibm {
            font-family: 'IBM Plex Sans', sans-serif;
          }
        `}
      </style>

      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-1796" data-mp="17rqor2y5zqvz">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-1797" data-mp="2e9drh629akjq">
          <Link to="/home" className="flex items-center text-gray-500 hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-1798" data-mp="2j7p1bgsjwv1y">
            <ArrowLeftIcon size={18} className="mr-2" data-id="element-1799" data-mp="1pbytrkq4yy7i" />
            Back to Home
          </Link>
          <div className="font-semibold text-[#1a0647]" data-id="element-1800" data-mp="1kcvyut3ve8d9">
            Font Evaluation Tool
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-12" data-id="element-1801" data-mp="1fdizx9zq5aub">
        <div className="mb-12 text-center" data-id="element-1802" data-mp="1af7r92l616do">
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-1803" data-mp="1ag12ogv2kk25">
            In-App Typography Comparison
          </h1>
          <p className="text-gray-500 max-w-2xl mx-auto" data-id="element-1804" data-mp="15mep8mh30c5a">
            Comparing Atkinson Hyperlegible vs IBM Plex Sans for the Caveo
            guided walkthrough experience.
          </p>
        </div>

        {/* Comparison Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1805" data-mp="rp9i0j5mt78g">
          {/* ATKINSON COLUMN */}
          <div className="space-y-8" data-id="element-1806" data-mp="mp53gyoaamkv">
            <div className="bg-[#1a0647] text-white p-4 rounded-t-xl text-center font-bold tracking-wide uppercase text-sm" data-id="element-1807" data-mp="mq6onvz0kpgb">
              Atkinson Hyperlegible
            </div>

            {/* Typography Scale */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1808" data-mp="hz18lh253ihs">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1809" data-mp="43fqzuy8k0ze">
                Typography Scale
              </h2>
              <div className="space-y-6" data-id="element-1810" data-mp="vtk4d9nkvnr4">
                <div data-id="element-1811" data-mp="vulr4bdyhyoo">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1812" data-mp="10rc8d21hz0bo">
                    H1 (32px / 2rem)
                  </div>
                  <h1 className="text-2xl md:text-4xl font-bold text-[#111111]" data-id="element-1813" data-mp="mz5u5lhwn3ev">
                    Secure your network
                  </h1>
                </div>
                <div data-id="element-1814" data-mp="1ern007amsixw">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1815" data-mp="1er4t8gqcembq">
                    H2 (24px / 1.5rem)
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-[#111111]" data-id="element-1816" data-mp="1jjeg1nw5v69s">
                    Router settings
                  </h2>
                </div>
                <div data-id="element-1817" data-mp="2za7aprwtko7e">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1818" data-mp="2z8ntnz3ca94k">
                    H3 (20px / 1.25rem)
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#111111]" data-id="element-1819" data-mp="3e0647hdfjbgj">
                    Step 1: Find your IP
                  </h3>
                </div>
                <div data-id="element-1820" data-mp="2la69ucgk1grx">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1821" data-mp="2lbqtv858thbj">
                    Body (16px / 1rem)
                  </div>
                  <p className="text-base text-gray-600" data-id="element-1822" data-mp="2v8dblo29vs9c">
                    This is standard body text used for instructions.
                  </p>
                </div>
                <div data-id="element-1823" data-mp="2qb3qulptw4ru">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1824" data-mp="ahcw3k3f7etr">
                    Small (14px / 0.875rem)
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1825" data-mp="5hqkff38q6n2">
                    Helper text and secondary information.
                  </p>
                </div>
              </div>
            </div>

            {/* Readability Test */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1826" data-mp="2g7qadwkgbelw">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1827" data-mp="2k9tmmney2n88">
                Readability Test
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" data-id="element-1828" data-mp="2u4vcxmkyhvce">
                Your home Wi-Fi network is the gateway to every device in your
                house. In this walkthrough, we'll check your router settings,
                update your password, and make sure your network is hidden from
                strangers. Most people can finish this in under 10 minutes.
              </p>
            </div>

            {/* UI Simulation */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1829" data-mp="3hv8wspte0nvw">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1830" data-mp="3rz60kj3weatl">
                In-App UI Simulation
              </h2>

              <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-1831" data-mp="3myi5nmcjt9u3">
                <div className="bg-[#f8f8f8] px-5 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-1832" data-mp="3i1rmur9d004z">
                  <span className="text-sm font-bold text-gray-500" data-id="element-1833" data-mp="3e17qhpwm10jw">
                    Step 2 of 5
                  </span>
                  <span className="text-sm font-bold text-[#631bb7]" data-id="element-1834" data-mp="em45serjhfgk">Skip</span>
                </div>
                <div className="h-1 w-full bg-gray-200" data-id="element-1835" data-mp="4ughgmqa4ejb">
                  <div className="h-1 bg-[#631bb7]" style={{
                  width: '40%'
                }} data-id="element-1836" data-mp="4t5bcg9d2up1"></div>
                </div>
                <div className="p-6" data-id="element-1837" data-mp="xcc0c8h6axl5">
                  <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1838" data-mp="sk2g992qorqs">
                    Change your admin password
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1839" data-mp="2mt7kw3tnpdcv">
                    Your router came with a default password printed on the
                    back. Hackers know these defaults. Let's change it to
                    something secure.
                  </p>
                  <div className="space-y-3 mb-8" data-id="element-1840" data-mp="2i0eg5fy6u50s">
                    <label className="flex items-center p-4 border-2 border-[#631bb7] bg-[#631bb7] bg-opacity-5 rounded-lg cursor-pointer" data-id="element-1841" data-mp="2hz3d5ickh1aq">
                      <div className="w-5 h-5 rounded-full border-2 border-[#631bb7] flex items-center justify-center mr-3" data-id="element-1842" data-mp="29115wl28pcf0">
                        <div className="w-2.5 h-2.5 bg-[#631bb7] rounded-full" data-id="element-1843" data-mp="1u4irys2r8ec7"></div>
                      </div>
                      <span className="font-medium text-[#111111]" data-id="element-1844" data-mp="1z2u0mzhbcisu">
                        I'm ready to change it
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-gray-300" data-id="element-1845" data-mp="3tgl9vxvqd0nr">
                      <div className="w-5 h-5 rounded-full border-2 border-gray-300 mr-3" data-id="element-1846" data-mp="1ht9auk7xsig0"></div>
                      <span className="font-medium text-gray-700" data-id="element-1847" data-mp="1cvpyxqypohr8">
                        I need help finding it
                      </span>
                    </label>
                  </div>
                  <button className="w-full bg-[#631bb7] text-white py-3.5 rounded-lg font-bold text-base hover:bg-[#521099] transition-colors" data-id="element-1848" data-mp="1mqhyh0buteon">
                    Continue
                  </button>
                </div>
              </div>
            </div>

            {/* Weights */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1849" data-mp="2agc9dccm4t69">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1850" data-mp="25jvk2etog8rl">
                Weight Showcase
              </h2>
              <div className="space-y-4" data-id="element-1851" data-mp="b4sygs7r1aty">
                <div className="flex items-center justify-between" data-id="element-1852" data-mp="b5ul7ty4nlri">
                  <span className="text-lg font-normal" data-id="element-1853" data-mp="3lhb5v9o7catp">Regular (400)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1854" data-mp="3qfus7b6pjoml">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1855" data-mp="3v7w2irkbf59z">
                  <span className="text-lg font-bold" data-id="element-1856" data-mp="40tbc04h8yzr">Bold (700)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1857" data-mp="32hx5a8vyw1u8">
                    The quick brown fox
                  </span>
                </div>
                <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800 font-sans" data-id="element-1858" data-mp="37hrwyenkgvgc">
                  Note: Atkinson Hyperlegible only comes in Regular and Bold
                  weights natively.
                </div>
              </div>
            </div>

            {/* UI Elements */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-atkinson" data-id="element-1859" data-mp="rrylpzrnez2o">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1860" data-mp="wr1sppr6vfda">
                Buttons & Elements
              </h2>
              <div className="space-y-6" data-id="element-1861" data-mp="2c8y481ezvxhh">
                <div className="flex flex-wrap gap-4" data-id="element-1862" data-mp="2c9znuua2tsat">
                  <button className="bg-[#631bb7] text-white px-5 py-2.5 rounded-lg font-bold" data-id="element-1863" data-mp="27g4zvenfur5x">
                    Primary Button
                  </button>
                  <button className="bg-white text-[#111111] border border-gray-300 px-5 py-2.5 rounded-lg font-bold" data-id="element-1864" data-mp="1xj0ma37ns40q">
                    Secondary
                  </button>
                </div>
                <div className="flex flex-wrap gap-3" data-id="element-1865" data-mp="1oiast65vepq6">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide flex items-center" data-id="element-1866" data-mp="1oiubip3chi59">
                    <CheckCircle2Icon size={14} className="mr-1" data-id="element-1867" data-mp="3iw3cfshtrvbw" /> Completed
                  </span>
                  <span className="bg-[#1a0647] text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-1868" data-mp="3dxibtrynv9mx">
                    Required
                  </span>
                </div>
                <div data-id="element-1869" data-mp="1nzloyrc0nag1">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-1870" data-mp="1o0509p75v0l3">
                    Email Address
                  </label>
                  <input type="text" placeholder="name@family.com" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base placeholder-gray-400" readOnly data-id="element-1871" data-mp="21x0k8coyacfx" />
                </div>
              </div>
            </div>
          </div>

          {/* IBM PLEX SANS COLUMN */}
          <div className="space-y-8" data-id="element-1872" data-mp="1j1tld020dzw0">
            <div className="bg-[#1a0647] text-white p-4 rounded-t-xl text-center font-bold tracking-wide uppercase text-sm" data-id="element-1873" data-mp="1e9k3m7b1s64t">
              IBM Plex Sans
            </div>

            {/* Typography Scale */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1874" data-mp="mim8kwl7k9g6">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1875" data-mp="cepfbx8bq4wq">
                Typography Scale
              </h2>
              <div className="space-y-6" data-id="element-1876" data-mp="h6pbrfp6qfok">
                <div data-id="element-1877" data-mp="2ghz5gluzqvs">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1878" data-mp="2h18wa1cv8yq">
                    H1 (32px / 2rem)
                  </div>
                  <h1 className="text-2xl md:text-4xl font-bold text-[#111111]" data-id="element-1879" data-mp="7fm949glxsn6">
                    Secure your network
                  </h1>
                </div>
                <div data-id="element-1880" data-mp="1049vy9h08q2u">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1881" data-mp="103i336esl6g9">
                    H2 (24px / 1.5rem)
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-[#111111]" data-id="element-1882" data-mp="l93ulzsutffu">
                    Router settings
                  </h2>
                </div>
                <div data-id="element-1883" data-mp="35vf20q61e1u8">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1884" data-mp="35z2yny6s34d6">
                    H3 (20px / 1.25rem)
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#111111]" data-id="element-1885" data-mp="1hdudk1g89k4l">
                    Step 1: Find your IP
                  </h3>
                </div>
                <div data-id="element-1886" data-mp="1cgcbmv0mo563">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1887" data-mp="17n9holrxutpd">
                    Body (16px / 1rem)
                  </div>
                  <p className="text-base text-gray-600" data-id="element-1888" data-mp="12nena88yflzk">
                    This is standard body text used for instructions.
                  </p>
                </div>
                <div data-id="element-1889" data-mp="tn8gt6bobm9w">
                  <div className="text-xs text-gray-400 mb-1 font-sans" data-id="element-1890" data-mp="tmow5hun2js6">
                    Small (14px / 0.875rem)
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-1891" data-mp="oqrjblil3vk5">
                    Helper text and secondary information.
                  </p>
                </div>
              </div>
            </div>

            {/* Readability Test */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1892" data-mp="2e3v0rw0y7sjs">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1893" data-mp="2lndwn2vajg9s">
                Readability Test
              </h2>
              <p className="text-base text-gray-700 leading-relaxed" data-id="element-1894" data-mp="2qke6zpz6b56p">
                Your home Wi-Fi network is the gateway to every device in your
                house. In this walkthrough, we'll check your router settings,
                update your password, and make sure your network is hidden from
                strangers. Most people can finish this in under 10 minutes.
              </p>
            </div>

            {/* UI Simulation */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1895" data-mp="2clwm000nk6sh">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1896" data-mp="2hm27eygbwx24">
                In-App UI Simulation
              </h2>

              <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-1897" data-mp="3o3paj2oc1sqe">
                <div className="bg-[#f8f8f8] px-5 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-1898" data-mp="3syuv9y6011cw">
                  <span className="text-sm font-semibold text-gray-500" data-id="element-1899" data-mp="3qo3v9dc6x8nf">
                    Step 2 of 5
                  </span>
                  <span className="text-sm font-semibold text-[#631bb7]" data-id="element-1900" data-mp="4ej9w3f2p1gz">
                    Skip
                  </span>
                </div>
                <div className="h-1 w-full bg-gray-200" data-id="element-1901" data-mp="3vjj5lvazomf3">
                  <div className="h-1 bg-[#631bb7]" style={{
                  width: '40%'
                }} data-id="element-1902" data-mp="dezc79k2y2k9"></div>
                </div>
                <div className="p-6" data-id="element-1903" data-mp="n5k9mto0p11l">
                  <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1904" data-mp="n4ixsmz6gait">
                    Change your admin password
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1905" data-mp="x38g2guzjwzl">
                    Your router came with a default password printed on the
                    back. Hackers know these defaults. Let's change it to
                    something secure.
                  </p>
                  <div className="space-y-3 mb-8" data-id="element-1906" data-mp="1bocl0t2xar84">
                    <label className="flex items-center p-4 border-2 border-[#631bb7] bg-[#631bb7] bg-opacity-5 rounded-lg cursor-pointer" data-id="element-1907" data-mp="1fqqzl0zk74tl">
                      <div className="w-5 h-5 rounded-full border-2 border-[#631bb7] flex items-center justify-center mr-3" data-id="element-1908" data-mp="11udktzmethit">
                        <div className="w-2.5 h-2.5 bg-[#631bb7] rounded-full" data-id="element-1909" data-mp="s2g6wl40obge"></div>
                      </div>
                      <span className="font-medium text-[#111111]" data-id="element-1910" data-mp="wt6cnzgcugbm">
                        I'm ready to change it
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-gray-300" data-id="element-1911" data-mp="o0maip0uttm1">
                      <div className="w-5 h-5 rounded-full border-2 border-gray-300 mr-3" data-id="element-1912" data-mp="932c60ygqwou"></div>
                      <span className="font-medium text-gray-700" data-id="element-1913" data-mp="e2ong4uqe2v0">
                        I need help finding it
                      </span>
                    </label>
                  </div>
                  <button className="w-full bg-[#631bb7] text-white py-3.5 rounded-lg font-semibold text-base hover:bg-[#521099] transition-colors" data-id="element-1914" data-mp="3mc7pm6th91cl">
                    Continue
                  </button>
                </div>
              </div>
            </div>

            {/* Weights */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1915" data-mp="dx7k555511jh">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1916" data-mp="8x1n19g3mmu0">
                Weight Showcase
              </h2>
              <div className="space-y-4" data-id="element-1917" data-mp="3wnezrehzcvz">
                <div className="flex items-center justify-between" data-id="element-1918" data-mp="3v51gl1iadp6a">
                  <span className="text-lg font-normal" data-id="element-1919" data-mp="3v6vxm4qfsx53">Regular (400)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1920" data-mp="2oqackoxv9o81">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1921" data-mp="z83pex3oc6qs">
                  <span className="text-lg font-medium" data-id="element-1922" data-mp="z5qxps846i0j">Medium (500)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1923" data-mp="14781bvhzgikt">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1924" data-mp="1dwzx2t1tjhqv">
                  <span className="text-lg font-semibold" data-id="element-1925" data-mp="1dyb0grrcqnhg">SemiBold (600)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1926" data-mp="1ivb6x3s45s93">
                    The quick brown fox
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-1927" data-mp="1rvzk5w9onokx">
                  <span className="text-lg font-bold" data-id="element-1928" data-mp="1wvc5udotiplx">Bold (700)</span>
                  <span className="text-sm text-gray-400 font-sans" data-id="element-1929" data-mp="1wukkrwsuka9w">
                    The quick brown fox
                  </span>
                </div>
              </div>
            </div>

            {/* UI Elements */}
            <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm font-ibm" data-id="element-1930" data-mp="2j5sp9cd5yqz">
              <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-6 font-sans" data-id="element-1931" data-mp="24cihf0pxjqvp">
                Buttons & Elements
              </h2>
              <div className="space-y-6" data-id="element-1932" data-mp="2e3d3o536eqh5">
                <div className="flex flex-wrap gap-4" data-id="element-1933" data-mp="2e6irzi3zdobt">
                  <button className="bg-[#631bb7] text-white px-5 py-2.5 rounded-lg font-semibold" data-id="element-1934" data-mp="296wdl5cf221f">
                    Primary Button
                  </button>
                  <button className="bg-white text-[#111111] border border-gray-300 px-5 py-2.5 rounded-lg font-semibold" data-id="element-1935" data-mp="1gh5z2v6vgy4s">
                    Secondary
                  </button>
                </div>
                <div className="flex flex-wrap gap-3" data-id="element-1936" data-mp="1qfdg1e15vg6s">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide flex items-center" data-id="element-1937" data-mp="1qdsj5hrdjl5r">
                    <CheckCircle2Icon size={14} className="mr-1" data-id="element-1938" data-mp="31v20nyqy034f" /> Completed
                  </span>
                  <span className="bg-[#1a0647] text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide" data-id="element-1939" data-mp="39dibhean8imf">
                    Required
                  </span>
                </div>
                <div data-id="element-1940" data-mp="30dv66hesmso3">
                  <label className="block text-sm font-semibold text-gray-700 mb-1" data-id="element-1941" data-mp="30eo6p0n5slxs">
                    Email Address
                  </label>
                  <input type="text" placeholder="name@family.com" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base placeholder-gray-400" readOnly data-id="element-1942" data-mp="3s49kgeqpy70a" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}